import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SdfBusyIndicator, SdfButton, SdfCheckbox, SdfFocusPane, SdfInput } from '@synerg/react-components';
import { get, uniqueId } from 'lodash';
import Toast from '../common/toast';

function AcceleratedPartner({ partner }) {
  const [isAccelerated, setIsAccelerated] = useState(false);
  const [carAppId, setCarAppId] = useState('');
  const [partnerConsumerApp, setPartnerConsumerApp] = useState({});
  const [toast, setToast] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleResponse = (message, status = 'error') => {
    setToast({ key: uniqueId(), status: status, message: message, showToast: true });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setBusy(true);
        const { data: { acceleratedPartner = {} } } = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/si/partner/accelerate/${partner.partnerId}`);
        setBusy(false);
        if (get(acceleratedPartner, 'consumerAppId', false)) {
          setPartnerConsumerApp(acceleratedPartner);
          setIsAccelerated(true);
          setCarAppId(acceleratedPartner.consumerAppId);
        }
      }
      catch (error) {
        setBusy(false);
        const errorMessage = get(error, 'response.data.message', 'Something went wrong while fetching accelerated partner details.');
        handleResponse(errorMessage);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCheckboxClick = (value) => {
    if (get(partnerConsumerApp, 'consumerAppId', false) && !value) {
      setShowConfirmModal(true);
    } else {
      setIsAccelerated(value);
    }
  }

  const onCarAppID = (value) => {
    setCarAppId(value);
  }

  const onSave = async () => {
    const consumerAppId = get(partnerConsumerApp, 'consumerAppId', false);
    if (consumerAppId !== carAppId) {
      try {
        setBusy(true);
        const { data: { success } } = await axios.post(
          `${import.meta.env.VITE_ROOT_PATH}/api/si/partner/accelerate`,
          {
            partnerID: partner.partnerId,
            carAppID: carAppId,
          }
        );
        if (success) {
          const message = consumerAppId ? 'Partner has been updated successfully' : 'Partner has been accelerated successfully';
          handleResponse(message, 'success');
          setPartnerConsumerApp({ consumerAppId: carAppId });
        } else {
          handleResponse('Something went wrong while accelerating the partner',);
        }
        setBusy(false);
      } catch (error) {
        setBusy(false);
        const errorMessage = get(error, 'response.data.message', 'Something went wrong while accelerating the partner.');
        handleResponse(errorMessage);
      }
    }
  }

  const onDeleteAcceleratedPartner = async () => {
    setShowConfirmModal(false);
    try {
      setBusy(true);
      const { data: { success } } = await axios.delete(
        `${import.meta.env.VITE_ROOT_PATH}/api/si/partner/accelerate/${partner.partnerId}`,
        {
          partnerID: partner.partnerId,
        }
      );
      if (success) {
        handleResponse('Partner has been removed from accelerated list', 'success');
        setIsAccelerated(false);
        setCarAppId('');
        setPartnerConsumerApp({});
      } else {
        handleResponse('Something went wrong while updating the partner',);
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      const errorMessage = get(error, 'response.data.message', 'Something went wrong while updating the partner.');
      handleResponse(errorMessage);
      handleResponse('Something went wrong while updating the partner',);
    }
  }

  const Confirmation = ({ confirmationMessage }) => {
    return (<SdfFocusPane
      paneType='floating'
      visible={true}
      size='small'
      hideAcceptButton={true}
      hideDismissButton={true}
    >
      <span slot='title'>Are you sure?</span>
      <div className='text-body-01 mx-6 text-left'>
        {confirmationMessage}
      </div>
      <div slot='custom-buttons' className='mt-3'>
        <SdfButton onClick={() => { setShowConfirmModal(false) }}>
          Cancel
        </SdfButton>
        <SdfButton
          emphasis='primary'
          onClick={() => {
            onDeleteAcceleratedPartner()
          }}
          className='ml-3'
        >
          <div style={{ height: '1.625rem' }}>
            Yes
          </div>
        </SdfButton>
      </div>
    </SdfFocusPane >);
  };

  return (
    <div>
      {toast && <Toast
        key={toast.key}
        status={toast.status}
        message={toast.message}
        showToast={toast.showToast}
      />}
      {busy && <SdfBusyIndicator
        style={{ color: '#1a8099' }}
        size='xl'
        fullScreen={true}
      ></SdfBusyIndicator>
      }
      <h1 className='text-heading-05'>Accelerated Integrator</h1>
      <p className='text-body-05'>Select or deselect based on partner's designation as an accelerated integrator in API Central</p>
      <SdfCheckbox
        label='This partner is an active Accelerated Integrator'
        onSdfChange={(e) => onCheckboxClick(e.detail)}
        value={isAccelerated}
        checked={isAccelerated}
      />
      {isAccelerated && <div className={'mt-5 ml-5 flex items-end'}>
        <SdfInput
          className={'mr-5 w-1/2'}
          label={'CAR App ID'}
          placeholder={'Enter CAR App ID'}
          value={carAppId}
          onSdfInput={($event) => {
            onCarAppID($event.detail)
          }}
        >
        </SdfInput>
        <SdfButton emphasis='primary' {...((!carAppId || !isAccelerated) && { disabled: true })} onClick={onSave}>Save</SdfButton>
      </div>
      }
      {showConfirmModal && <Confirmation confirmationMessage='By removing this partner from the accelerated integrators list they will no longer be able to work on client projects as an accelerated integrator.' />}
    </div>
  )
}
export default AcceleratedPartner;

